import React from 'react';

import {
  ContentLayout,
  NewsletterPageContent,
} from '@silvertours/common-landingpages-view';
import { BenefitsLegacy, StageLegacy } from '@silvertours/front-features';

import { Body } from './body';

const NewsletterContent = ({
  content: _content,
  ...commonProps
}: ContentLayout<NewsletterPageContent>) => (
  <Body
    variant={{ kind: 'newsletter' }}
    bodyTop={<StageLegacy.NewsletterStage />}
    content={({ containerModule }) => [
      containerModule(
        'usp',
        <BenefitsLegacy.Usp translationKey="newsletterUsps" />,
      ),
    ]}
    {...commonProps}
  />
);

export { NewsletterContent };
